export function hidden(value) {
    // 将数字转换为字符串
    const str = String(value);

    // 隐藏金额数字的逻辑处理
    const hiddenStr = str.replace(/\d/g, '*');

    return hiddenStr;
}
